<template>
  <transition name="slide-fade">
    <div class='d-flex justify-content-between'>
        <strong class='align-self-center f-18'>{{$ml.get('EXPRESSION')}}</strong>
     
        <div class='cardArea justify-content-center pb-2'>
          <objectExplorer   :currentPath='objectValuePath' :selectedObject="selectedObject.key" v-bind:item='item'  @change='updateValuePath'></objectExplorer>
          <select class='custom-select form-control  input-padding' v-model='operator'>
            <option v-if='!isDateField(objectValuePath)'> = </option>
            <option v-if='isDateField(objectValuePath) || numberTypeFields.includes(getFieldType(objectValuePath,allCustomFields))'> &gt </option>
            <option v-if='isDateField(objectValuePath) || numberTypeFields.includes(getFieldType(objectValuePath,allCustomFields))'> &gt= </option>
            <option v-if='isDateField(objectValuePath) || numberTypeFields.includes(getFieldType(objectValuePath,allCustomFields))'> &lt </option>
            <option v-if='isDateField(objectValuePath) || numberTypeFields.includes(getFieldType(objectValuePath,allCustomFields))'> =&lt </option>
            <option > exists </option>
            <option v-if='subItemIsObject'> matches </option>
            <option v-if='isDateField(objectValuePath)'> between </option>
            <option v-else > contains </option> 
          </select>
          <div v-if="operator=='between'" key="date-between" class="d-flex align-items-center flex-wrap mt-2 between-dates-wrapper">
            <div class="between-date-field mr-2">
              <span class="between-date-label">{{$ml.get('START') || 'Başlangıç'}}</span>
              <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="betweenstartdate" class="new-ctk-h30" label="" v-model="betweenStart" format="YYYY-MM-DD HH:mm" formatted="lll" :noLabel="true" :range="false" :onlyDate="false" :auto-close="false"></vue-ctk-date-time-picker>
            </div>
            <div class="between-date-field">
              <span class="between-date-label">{{$ml.get('END_DATE') || 'Bitiş'}}</span>
              <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="betweenenddate" class="new-ctk-h30" label="" v-model="betweenEnd" format="YYYY-MM-DD HH:mm" formatted="lll" :noLabel="true" :range="false" :onlyDate="false" :auto-close="false"></vue-ctk-date-time-picker>
            </div>
          </div>

          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='isCandidate'" key="isCandidate" class='custom-select form-control  input-padding' v-model='value'>
            <option value="true">{{$ml.get('YES')}}</option>
            <option value="false">{{$ml.get('NO')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='x'" key="x" class='custom-select form-control  input-padding' v-model='value'>
            <option value="true">{{$ml.get('ACTIVE')}}</option>
            <option value="false">{{$ml.get('PASSIVE')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='currency'" key="currency" class='custom-select form-control  input-padding' v-model='value'>
            <option v-for="(cur,index) in currencyData()" v-bind:key="index" :value="cur.id">{{cur.label}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='stageId'" key="stageId" class='custom-select form-control  input-padding' v-model='value'>
            <option value="1">{{$ml.get('STEP_1')}}</option>
            <option value="2">{{$ml.get('STEP_2')}}</option>
            <option value="3">{{$ml.get('STEP_3')}}</option>
            <option value="4">{{$ml.get('STEP_4')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='status'" key="status" class='custom-select form-control  input-padding' v-model='value'>
            <option value="1">{{$ml.get('OPEN')}}</option>
            <option value="2">{{$ml.get('WON')}}</option>
            <option value="3">{{$ml.get('NOT_WON')}}</option>
          </select>
          <div v-else-if="isDateField(objectValuePath)&&operator!=='exists'" key="date-single" class="mt-2">
          <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="singledate" class="new-ctk-h30" label="" format="YYYY-MM-DD HH:mm" v-model="singleDateValue" formatted="lll" :noLabel="true" :range="false" :onlyDate="false" :auto-close="false"></vue-ctk-date-time-picker>
          </div>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='rate'" class='form-control  input-padding' v-model='value'>
            <option value="1">{{$ml.get('NORMAL')}}</option>
            <option value="2">{{$ml.get('PRIORITY')}}</option>
            <option value="3">{{$ml.get('URGENT')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='source'" class='custom-select form-control  input-padding' v-model='value'>
              <option :value="$ml.get('ADVERTISING')">{{$ml.get('ADVERTISING')}}</option>
              <option :value="$ml.get('PHONE_CALL')">{{$ml.get('PHONE_CALL')}}</option>
              <option :value="$ml.get('EMPLOYEE_ORUENTATION')">{{$ml.get('EMPLOYEE_ORUENTATION')}}</option>
              <option :value="$ml.get('EXTERNAL_ORUENTATION')">{{$ml.get('EXTERNAL_ORUENTATION')}}</option>
              <option :value="$ml.get('ONLINE_STORE')">{{$ml.get('ONLINE_STORE')}}</option>
              <option :value="$ml.get('BUSINES_PARTNER')">{{$ml.get('BUSINES_PARTNER')}}</option>
              <option :value="$ml.get('PUBLIC_RELATIONS')">{{$ml.get('PUBLIC_RELATIONS')}}</option>
              <option :value="$ml.get('SEMINAR')">{{$ml.get('SEMINAR')}}</option>
              <option :value="$ml.get('FAIR')">{{$ml.get('FAIR')}}</option>
              <option value="Web">Web</option>
              <option :value="$ml.get('EMAILING')">{{$ml.get('EMAILING')}}</option>
              <option :value="$ml.get('SOCIAL_MEDIA')">{{$ml.get('SOCIAL_MEDIA')}}</option>
              <option :value="$ml.get('AFFILIATE_PROGRAMS')">{{$ml.get('AFFILIATE_PROGRAMS')}}</option>
              <option :value="$ml.get('SEO')">{{$ml.get('SEO')}}</option>
              <option :value="$ml.get('PAID_SEARCH')">{{$ml.get('PAID_SEARCH')}}</option>
              <option :value="$ml.get('ONLINE_ADVERTISING')">{{$ml.get('ONLINE_ADVERTISING')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='done'" class='custom-select form-control  input-padding' v-model='value'>
            <option value="true">{{$ml.get('COMPLETED')}}</option>
            <option value="false">{{$ml.get('INCOMPLETED')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='type'" class='custom-select form-control  input-padding' v-model='value'>
            <option value="1">{{$ml.get('CALL')}}</option>
            <option value="2">{{$ml.get('APPOINTMENT')}}</option>
            <option value="3">{{$ml.get('TASK')}}</option>
            <option value="4">{{$ml.get('E_MAIL')}}</option>
          </select>
          <div v-else-if="getFieldType(objectValuePath,allCustomFields)=='duration'">
          <vue-ctk-date-time-picker  :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="duration" class="new-ctk-h30" v-model="value" label="" format="HH:mm" formatted="HH:mm" :noLabel="true" :range="false" :onlyTime="true" :auto-close="false"></vue-ctk-date-time-picker>
          </div>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='userRoleId'" class='custom-select form-control  input-padding' v-model='value'>
            <option value="1">{{$ml.get('MANAGER')}}</option>
            <option value="2">{{$ml.get('AUTHORIZED')}}</option>
            <option value="3">{{$ml.get('USER')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='activation'" class='ustom-select form-control  input-padding' v-model='value'>
            <option value="true">{{$ml.get('YES')}}</option>
            <option value="false">{{$ml.get('NO')}}</option>
          </select>
          <select v-else-if="getFieldType(objectValuePath,allCustomFields)=='4'" class='custom-select form-control  input-padding' v-model='value'>
            <option v-for="(user,index) in users" v-bind:key="index" :value="user._id.$oid">{{user.name}} {{user.surName}}</option>
          </select>
          <div v-else-if="getFieldType(objectValuePath,allCustomFields)=='6'">
              <div class="form-check" v-for="opt in getFieldOptions(objectValuePath,allCustomFields)">
                <input class="form-check-input" type="radio" :name="objectValuePath" :value="opt.id" v-model='value' :id="objectValuePath+opt.id" >
                <label class="form-check-label" :for="objectValuePath+opt.id">
                  {{opt.label}}
                </label>
              </div>
          </div>
          <div v-else-if="getFieldType(objectValuePath,allCustomFields)=='7'">
            <div class="form-check" v-for="opt in getFieldOptions(objectValuePath,allCustomFields)" >
              <input class="form-check-input"  type="checkbox" :value="opt.id" v-model='valx' @change="value=valx" >
              <label class="form-check-label" >
              {{opt.label}}
              </label>
            </div>
          </div>
          <input v-else-if='numberTypeFields.includes(getFieldType(objectValuePath,allCustomFields)) && operator !== "matches" && operator !== "exists"' class='form-control  input-padding' type='number' v-model='value' @keyup.enter='sendQuery'/>
          <input v-else-if='operator !== "matches" && operator !== "exists"' class='form-control  input-padding' type='text' v-model='value' @keyup.enter='sendQuery'/>
          <group-builder v-if='operator === "matches"' :name='"innerGroup"' :item='subItem' :selectedSavedSearch="groupAsValue" @kill='resetOperator' @change='updateGroupQuery'></group-builder>
        </div>
        
      
      <button type="button" class="btn-remove" @click='removeThis'>
        <i>&#10005;</i>
      </button>
    </div>
  </transition>
</template>

<script>
  import Vue from 'vue'
  import objectExplorer from './object-explorer.vue'
  import {mapGetters,mapState} from 'vuex'
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
  Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
  export default {
    name: 'expression-builder',
    components: {
      objectExplorer
    },
    props: ['item', 'name', 'selectedObject'],
    data () {
      return {
        value: '',
        valx:[],
        operator:'=',
        objectValuePath: '',
        groupQuery: '',
        dateTypeFields:['addDate','expectedDate','closedDate',3,'createdAt','modifiedAt','dueDate','doneDate','dob','wed_ann','updateDate','activityList.doneDate'],
        numberTypeFields:['value','prices','quantity','itemPrice','price',2,5],
        groupAsValue:{},
        dateShortcuts:[
            { key: 'thisQuarter', label: this.$ml.get('THIS_QUARTER'), value: 'quarter' },//
            { key: 'thisMonth', label: this.$ml.get('THIS_MONTH'), value: 'month' },//
            { key: 'lastMonth', label: this.$ml.get('LAST_MONTH'), value: '-month' },//
            { key: 'thisWeek', label: this.$ml.get('THIS_WEEK'), value: 'isoWeek' },//
            { key: 'lastWeek', label: this.$ml.get('LAST_WEEK'), value: '-isoWeek' },//
            { key: 'thisYear', label: this.$ml.get('THIS_YEAR'), value: 'year' },//
            { key: 'lastYear', label: this.$ml.get('LAST_YEAR'), value: '-year' }//
        ]
        
      }
    },
    methods: {
      isDateField: function (path) {
        if (!path) return false
        var fieldType = this.getFieldType(path, this.allCustomFields)
        return this.dateTypeFields.includes(fieldType) || this.dateTypeFields.includes(path)
      },
      formatToIsoUtc: function (val, defaultTime, endOfMinute) {
        if (!val) return ''
        if (typeof val === 'string') {
          // If already in ISO format with Z
          if (val.indexOf('T') !== -1 && val.endsWith('Z')) {
            return val
          }
          // If has +00:00 or other offset, convert to Z
          if (val.indexOf('T') !== -1 && (val.includes('+') || (val.lastIndexOf('-') > val.indexOf('T')))) {
            var momentInst = this.$moment ? this.$moment(val) : null
            if (momentInst && momentInst.isValid()) return momentInst.toISOString()
          }
          // YYYY-MM-DD HH:mm
          if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(val)) {
            var sec = endOfMinute ? ':59.999Z' : ':00.000Z'
            return val.replace(' ', 'T') + sec
          }
          // YYYY-MM-DD HH:mm:ss
          if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(val)) {
            return val.replace(' ', 'T') + '.000Z'
          }
          // YYYY-MM-DD
          if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
            var time = defaultTime || '00:00:00.000'
            return val + 'T' + time + 'Z'
          }
        }
        var m = this.$moment ? this.$moment(val) : null
        if (m && m.isValid()) {
          return m.toISOString()
        }
        return val
      },
      getFieldType: function (path,cf){
        var item = path.split('.').slice(-1)[0]
        var typ = ''
        if(cf.find(col => col._id['$oid']==item)!=undefined){
          typ = cf.find(col => col._id['$oid']==item).field_type
        }else{
          typ = item
        }
        return typ 
      },
      getFieldOptions: function (path,cf){
        var item = path.split('.').slice(-1)[0]
        var opt = []
        if(cf.find(col => col._id['$oid']==item)!=undefined && cf.find(col => col._id['$oid']==item).options!=undefined){
          opt = cf.find(col => col._id['$oid']==item).options
        }else{
          opt = item
        }
        return opt 
      },
      update: function () {
        this.$emit('change', this.name, this.queryString)
      },

      updateValuePath: function (newPath) {
        // this.selectedObject = {}
        this.objectValuePath = newPath
        // console.log("objectValuePath update oldu")
        // console.log(this.objectValuePath)
        
        if(this.isDateField(this.objectValuePath)){
          this.operator = '>'
          if (typeof this.value === 'object' && this.value !== null) {
            this.value = this.value.start || ''
          }
        }else{
          this.operator = '='
        }
        this.draw()
        this.update()
      },

      updateGroupQuery: function (name, string) {
        //console.log('group changed ' + string)
        this.groupQuery = string
        this.$emit('change', this.name, this.queryString)
      },

      sendQuery: function () {
        this.$emit('sendQuery', this.queryString)
      },

      removeThis: function () {
        this.$emit('kill', this.name)
      },

      resetOperator: function () {
        this.operator = '='
      },
      draw: function(){
        if(this.selectedObject){
          if(this.isDateField(this.selectedObject.key)){//date
            var extractDate = function (val) {
              if (!val) return ''
              var str = (val && val.$date) ? val.$date : val
              if (typeof str === 'string' && str.indexOf('T') !== -1) {
                var p = str.split('T')
                var timePart = p[1].slice(0, 5) // HH:mm
                if (timePart && timePart !== '00:00') {
                  return p[0] + ' ' + timePart
                }
                return p[0]
              }
              return str
            }
            if(this.selectedObject.val.hasOwnProperty('$gte')&&this.selectedObject.val.hasOwnProperty('$lt')){
              
              var gte = extractDate(this.selectedObject.val.$gte)
              var lt = extractDate(this.selectedObject.val.$lt)
              this.operator='between'
              var rangeVal = {}
              rangeVal['start']=gte
              rangeVal['end']=lt
              this.value=rangeVal
              
            }else if(this.selectedObject.val.hasOwnProperty('$gt')){
              var gt = extractDate(this.selectedObject.val.$gt)
              this.operator=">"
              this.value = gt
            }else if(this.selectedObject.val.hasOwnProperty('$gte')){
              var gte = extractDate(this.selectedObject.val.$gte)
              this.operator=">="
              this.value = gte
            }else if(this.selectedObject.val.hasOwnProperty('$lt')){
              var lt = extractDate(this.selectedObject.val.$lt)
              this.operator="<"
              this.value = lt
            }else if(this.selectedObject.val.hasOwnProperty('$lte')){
              var lte = extractDate(this.selectedObject.val.$lte)
              this.operator="=<"
              this.value = lte
            }else if(this.selectedObject.val.hasOwnProperty('$exists')){
              var exists = this.selectedObject.val.$exists
              this.operator="exists"
              this.value = exists
            }
            
          }else if(this.selectedObject.val.hasOwnProperty('$in')){//checkbox
            // console.log('array geldi')
            this.valx = this.selectedObject.val.$in
          }else if(this.selectedObject.val.hasOwnProperty('$gt')){
            // console.log('array geldi')
            this.operator = '>'
            this.value = this.selectedObject.val.$gt
          }else if(this.selectedObject.val.hasOwnProperty('$gte')){
            // console.log('array geldi')
            this.operator = '>='
            this.value = this.selectedObject.val.$gte
          }else if(this.selectedObject.val.hasOwnProperty('$lt')){
            // console.log('array geldi')
            this.operator = '<'
            this.value = this.selectedObject.val.$lt
          }else if(this.selectedObject.val.hasOwnProperty('$lte')){
            // console.log('array geldi')
            this.operator = '=<'
            this.value = this.selectedObject.val.$lte
          }else if(this.selectedObject.val.hasOwnProperty('$lte')){
            // console.log('array geldi')
            this.operator = '=<'
            this.value = this.selectedObject.val.$lte
          }else if(this.selectedObject.val.hasOwnProperty('$exists')){
            // console.log('array geldi')
            this.operator = 'exists'
            this.value = this.selectedObject.val.$exists
          }else if(this.selectedObject.val.hasOwnProperty('$regex')){
            // console.log('array geldi')
            this.operator = 'contains'
            this.value = this.selectedObject.val.$regex
          }else if(this.selectedObject.val.hasOwnProperty('$elemMatch')){
            
            this.operator = 'matches'
            var itemSelObj = this.selectedObject.val.$elemMatch
            var selObj = {}
            var searchData = {}
            searchData['searchInput'] = JSON.stringify(itemSelObj)
            selObj['searchData'] = JSON.stringify(searchData)
            this.groupAsValue = selObj

          }else{//inputs and selectbox
          // console.log("buraya geliyormuuuuuuu ")
          // console.log(this.selectedObject.val)
            this.value = this.selectedObject.val
          }
        }
      }
    },

    computed: {
      ...mapGetters(['allCustomFields','users']),
      ...mapState(['cityList','localeLang']),
      conditionalOption:function(){
        console.log('computed eb')
        if(this.isDateField(this.objectValuePath)){
          return this.operator
        }else{
          this.operator = '='
          return this.operator
        }
      },
      betweenStart: {
        get() {
          if (this.value && typeof this.value === 'object') {
            return this.value.start || ''
          }
          if (typeof this.value === 'string' && this.value.indexOf(' ~ ') !== -1) {
            return this.value.split(' ~ ')[0] || ''
          }
          if (typeof this.value === 'string') {
            return this.value
          }
          return ''
        },
        set(val) {
          var currentEnd = (this.value && typeof this.value === 'object' && this.value.end)
            ? this.value.end
            : (typeof this.value === 'string' && this.value.indexOf(' ~ ') !== -1 ? this.value.split(' ~ ')[1] : '')
          this.value = { start: val || '', end: currentEnd || '' }
        }
      },
      betweenEnd: {
        get() {
          if (this.value && typeof this.value === 'object') {
            return this.value.end || ''
          }
          if (typeof this.value === 'string' && this.value.indexOf(' ~ ') !== -1) {
            return this.value.split(' ~ ')[1] || ''
          }
          return ''
        },
        set(val) {
          var currentStart = (this.value && typeof this.value === 'object' && this.value.start)
            ? this.value.start
            : (typeof this.value === 'string' ? (this.value.indexOf(' ~ ') !== -1 ? this.value.split(' ~ ')[0] : this.value) : '')
          this.value = { start: currentStart || '', end: val || '' }
        }
      },
      singleDateValue: {
        get() {
          if (this.value && typeof this.value === 'object') {
            return this.value.start || ''
          }
          return typeof this.value === 'string' ? this.value : ''
        },
        set(val) {
          this.value = val || ''
        }
      },
      selObjComp: function(){
        var arr = []
        if(this.selectedObject.key){
          arr = this.selectedObject.key.split('.')
          return arr
        }else{
          arr.push(this.objectValuePath)
          return arr
        }
        
      },
      queryString: function () {
        
        var string = '"' + this.objectValuePath + '":'
        

        if (this.objectValuePath.length > 0) {

          if (this.operator === 'exists') {
            string += '{ "$exists": true }'
          } 
          
          else if(this.getFieldType(this.objectValuePath,this.allCustomFields)=='7'){
            var obj = {}
            var array = []
            for(var str in this.value){
              array.push(this.value[str].toString())
            } 
            obj['$in']=array
            string += JSON.stringify(obj)
          }
            
          else if (this.operator === 'matches') {
            string += '{"$elemMatch": {' + this.groupQuery + '}}'
          }

          else if (this.operator === 'between') {
              var startDate = ''
              var endDate = ''
              if (this.value && typeof this.value === 'object') {
                startDate = this.value.start || ''
                endDate = this.value.end || ''
              } else if (typeof this.value === 'string' && this.value.indexOf(' ~ ') !== -1) {
                var parts = this.value.split(' ~ ')
                startDate = parts[0]
                endDate = parts[1]
              } else if (this.value) {
                startDate = this.value
                endDate = this.value
              }
              if (startDate && !endDate) {
                endDate = startDate
              } else if (!startDate && endDate) {
                startDate = endDate
              }
              var date={
                $gte:{$date: this.formatToIsoUtc(startDate, '00:00:00.000', false)},
                $lt:{$date: this.formatToIsoUtc(endDate, '23:59:59.999', true)}
              }
              string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
          }

          else if(this.operator === '>') {
            if(this.isDateField(this.objectValuePath)){
              var date={
                $gt:{$date: this.formatToIsoUtc(this.value, '00:00:00.000', false)}
              }
              string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
            }else{
              string += '{"$gt":' + (isNaN(Number(this.value)) ? JSON.stringify(this.value) : this.value) + '}'
            }
          }
          else if(this.operator === '>=') {
            if(this.isDateField(this.objectValuePath)){
              var date={
                $gte:{$date: this.formatToIsoUtc(this.value, '00:00:00.000', false)}
              }
              string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
            }else{
              string += '{"$gte":' + (isNaN(Number(this.value)) ? JSON.stringify(this.value) : this.value) + '}'
            }
          }
          else if (this.operator === '=<') {
            if(this.isDateField(this.objectValuePath)){
              var date={
                $lte:{$date: this.formatToIsoUtc(this.value, '23:59:59.999', true)}
              }
              string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
            }else{
              string += '{"$lte":' + (isNaN(Number(this.value)) ? JSON.stringify(this.value) : this.value) + '}'
            }
          }

          else if (this.operator === '<') {
            if(this.isDateField(this.objectValuePath)){
              var date={
                $lt:{$date: this.formatToIsoUtc(this.value, '00:00:00.000', false)}
              }
              string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
            }else{
              string += '{"$lt":' + (isNaN(Number(this.value)) ? JSON.stringify(this.value) : this.value) + '}'
            }
          }
          
          else if(this.numberTypeFields.includes(this.getFieldType(this.objectValuePath,this.allCustomFields))){
            if(this.operator == 'contains'){
                string += '{"$regex":' + this.value + ', "$options":"im"}'
            }else{
              string += this.value
            }
          }

          else if (this.operator == 'contains'){
              //string = '"' + this.objectValuePath + '":"' + this.value + '"'
              string += '{"$regex":"' + this.value + '", "$options":"im"}'
          }

          else if (this.isDateField(this.objectValuePath)) {
            var dateVal = typeof this.value === 'string' ? this.value : (this.value && this.value.start ? this.value.start : '')
            var date = {
              $gte: {$date: this.formatToIsoUtc(dateVal, '00:00:00.000', false)},
              $lte: {$date: this.formatToIsoUtc(dateVal, '23:59:59.999', true)}
            }
            string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
          }

          else if (!isNaN(Number(this.value))) {
              string += this.value
          }
          else {
            // if(this.dateTypeFields.includes(this.objectValuePath)){
            //   // console.log("this.value tarih giden")
            //   // console.log(this.value)
            //   var date={
            //     $gte:{$date:this.value+"T00:00:00.000Z"},
            //     $lt:{$date:this.value+"T23:59:00.000Z"}
            //   }
            //   string = '"' + this.objectValuePath + '":' + JSON.stringify(date)
            // }
            if(this.value == "true" || this.value == "false"){
              string = '"' + this.objectValuePath + '":' + this.value
            }else{
              string = '"' + this.objectValuePath + '":"' + this.value + '"'
            }
          }
          
        }
        return string
      },

      subItem: function () {
        if(this.selectedObject.val!==undefined){
          //this.value = this.selectedObject.val
        }else{
          this.value=""
        }
        
        var pathNames = this.objectValuePath.split('.')
        var currentObject = this.item
        for (var i = 0; i < pathNames.length; i++) {
          currentObject = currentObject[pathNames[i]]
        }
        
        return currentObject
      },

      subItemIsObject: function () {
        if (this.subItem) {
          if (typeof this.subItem === 'object') {
            return true
          }
        }
        return false
      }
    },

    watch: {
      operator: function (newOp) {
        if (newOp !== 'between') {
          if (typeof this.value === 'object' && this.value !== null) {
            this.value = this.value.start || ''
          }
        } else {
          if (typeof this.value !== 'object' || this.value === null) {
            this.value = { start: this.value || '', end: '' }
          }
        }
        this.update()
      },

      value: function () {
        // console.log("value updated in expression builder as-")
        // console.log(this.value)
        // console.log("-value updated as")
        this.update()
      }
    },

    beforeCreate: function () {
      //console.log('Expression builder beforeCreate')
      this.$options.components['groupBuilder'] = require('./group-builder.vue').default
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h30 input{
  height: 30px!important;
  min-height: 30px!important;
}
  .sub-item-container {
    margin: 0;
    display: inline;
  }
  .btn-remove{
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
  .btn-remove i{
    border-radius: 15px;
    padding: 0px 3px;
    font-weight: 400;
    font-style: normal;
    background-color: #f44336;
    color: #FFF;
  }
  .form-check{
    margin-right: 10px;
    float: left;    
    word-break: break-all;
  }

  input[type="radio"]:checked+label {
    -webkit-box-shadow: 0 0 0 3px #3766a0;
    box-shadow: 0 0 0 3px #3766a0;
  }

  input[type="checkbox"]:checked+label {
    -webkit-box-shadow: 0 0 0 3px #3766a0;
    box-shadow: 0 0 0 3px #3766a0;
  }
  .cardArea{
    display: -ms-flexbox!important;
    display: flex!important;    
    flex-wrap: wrap;
  }
  .cardArea>*{
    margin: 0 10px;  
    margin-top: 8px;
  }

  .form-control {
    width: 200px;
    height: 30px;
    font-size: 15px;
  }

  button {
    padding-top: 0;
    padding-left: 2px;
    padding-right: 2px;
  }

  img {
    width: 18px;
    height: 18px;
  }

  .card {
    margin: 5px;
    margin-top: 0;
  }

  select {
    padding: 4px;
    padding-right: 28px;
    font-size: 12px;
    height: 28px;
    text-align-last: center;
  }

  .slide-fade-enter-active {
    transition: all .15s ease;
  }

  .slide-fade-enter {
    transform: translateY(10px);
    opacity: 0;
  }
  
.between-dates-wrapper {
  margin-top: 4px;
}
.between-date-field {
  display: flex;
  flex-direction: column;
}
.between-date-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  display: block;
  margin-bottom: 2px;
}
.new-ctk-h30 {
  min-width: 260px;
  width: 260px;
}
.new-ctk-h30:has(#betweenstartdate),
.new-ctk-h30:has(#betweenenddate),
div:has(> #betweenstartdate),
div:has(> #betweenenddate),
.new-ctk-h30:first-child {
  min-width: 260px;
}
.new-ctk-h30 :deep(.field-input) {
  height: 30px !important;
  min-height: 30px !important;
  font-size: 13px !important;
  padding-left: 10px !important;
  padding-right: 30px !important;
}
.new-ctk-h30 :deep(.datepicker) {
  max-width: 520px !important;
  min-width: 440px !important;
  width: auto !important;
}
.new-ctk-h30 :deep(.pickers-container) {
  display: flex !important;
  flex-direction: row !important;
  min-width: 440px !important;
}
.new-ctk-h30 :deep(.time-picker) {
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
}
.new-ctk-h30 :deep(.time-picker-column-item) {
  height: 32px !important;
  min-height: 32px !important;
  font-size: 14px !important;
}
.new-ctk-h30 :deep(.time-picker-column-item-effect) {
  height: 28px !important;
}

@media screen and (min-width: 1366px) {
  .form-control {
    width: 200px;
    height: 42px;
    font-size: 18px;
  }
  .new-ctk-h30 {
    min-width: 280px;
    width: 280px;
  }
  .new-ctk-h30 :deep(.field-input) {
    height: 42px !important;
    min-height: 42px !important;
    font-size: 16px !important;
  }
}
</style>
